import { createSelector } from 'reselect';

const dashboardSelector = state => state.subscription.dashboard;
const userSelector = state => state.subscription.user;

export const selectSixtyDayCourse = createSelector(dashboardSelector, dashboard => {
  const sixtyDayCourse = dashboard.getIn(['data', 'sixtyDayCourse']);

  return sixtyDayCourse ? sixtyDayCourse.toJS() : null;
});

export const selectLatestEpisodes = createSelector(dashboardSelector, dashboard => {
  const latestEpisodes = dashboard.getIn(['data', 'latestEpisodes']);

  return latestEpisodes ? latestEpisodes.toJS() : null;
});

export const selectLatestFavorites = createSelector(dashboardSelector, dashboard => {
  const latestFavorites = dashboard.getIn(['data', 'latestFavorites']);

  return latestFavorites ? latestFavorites.toJS() : null;
});

export const selectLatestBadge = createSelector(userSelector, user => {
  const badges = user.getIn(['data', 'badges']);

  return badges.size
    ? badges
        .sortBy(badge => badge.get('_pivot_created_at'))
        .last()
        .toJS()
    : null;
});



// WEBPACK FOOTER //
// ./src/subscription/dashboard/redux/selectors.js